import React from 'react';
import styled from 'styled-components';
import { useEditMode } from '../../hooks/useEditMode';
import HeadlessTextArea from '../headless/textarea/HeadlessTextArea';
import { TextAlignment } from '../../enum/EnumRepository';
import { StyledDivComponent, StyledTextAreaComponent } from '../../dto/StyleCompRepository';
import { useStandardAlertStore } from '../../store/portal/alertStore';
import { getPageMessage } from '../../constants/pageMessages';

interface MoleculeTextareaDescriptionProps {
  value: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  StyledTextarea: StyledTextAreaComponent;
  StyledDescription: StyledDivComponent;
  alignment?: TextAlignment;
  placeholder?: string;
  maxLength?: number;
  maxRows?: number;
}

const MoleculeTextareaDescription: React.FC<MoleculeTextareaDescriptionProps> = ({
  value,
  handleChange,
  StyledTextarea,
  StyledDescription,
  alignment,
  placeholder,
  maxLength,
  maxRows
}) => {
  const { isEditMode } = useEditMode();
  const { setTextLengthExceededAlert } = useStandardAlertStore();

  const handleChangeWithLimit = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (maxLength && e.target.value.length > maxLength) {
      setTextLengthExceededAlert(maxLength);
      return;
    }
    handleChange(e);
  }

  return (
    <>
      {isEditMode ? (
        <HeadlessTextAreaWrapper>
          {maxLength && (
            <LimitDiv>
              {value.toString().length} / {maxLength}
            </LimitDiv>
          )}
          <HeadlessTextArea
            alignment={alignment ? alignment : TextAlignment.LEFT}
            content={value}
            placeholder={placeholder ? placeholder : getPageMessage('DESCRIPTION_PLACEHOLDER_DEFAULT')}
            handleChange={maxLength ? handleChangeWithLimit : handleChange}
            StyledTextArea={StyledTextarea}
            $maxRows={maxRows}
          />
        </HeadlessTextAreaWrapper>
      ) : (
        <StyledDescription $alignment={alignment ? alignment : TextAlignment.LEFT} >
          {value.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </StyledDescription>
      )}
    </>
  );
};

const HeadlessTextAreaWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const LimitDiv = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_04};
  user-select: none;
  z-index: 2;
`;


export default MoleculeTextareaDescription;
